window.pages["productlinerecipes.show"] = {
    page: document.body.getAttribute('page'),

    init: function () {
        window.components.accordionItem.init();
    },
};
